import { IDictionaryEntityDto } from '@/types/IDictionaryEntityDto';
import {
  IDictNotificationType,
  INotificationDto,
} from '@/types/INotificationDto';
import { IContentDto, IDictContentType } from '@/types/IContentDto';
import { IPagedDto } from '@/types/IPagedDto';

export enum MessageChannelType {
  TAXPAYER_PERSONAL_ACCOUNT = 'TAXPAYER_PERSONAL_ACCOUNT',
  EMAIL = 'EMAIL',
}

export interface IMessageDto {
  // Идентификатор записи
  id: string;

  // Дата и время создания
  created: string;

  // Дата и время изменения
  updated: string;

  // Статус сообщения (DictMessageStatus)
  status: IDictionaryEntityDto;

  // Дата и время отсылки
  sentAt: string;

  // Уведомление
  notification: INotificationDto;

  // Заголовок сообщения
  subject: string;

  // Тело сообщения(TEXT)
  body: string;

  // Тело сообщения(BINARY) string($byte)
  bodyBin: string;

  // Вложения
  attachments: IPagedDto<IContentDto>;

  // Канал доставки уведомления (DictMessageChannel)
  channel: IDictionaryEntityDto;

  // Тип содержимого
  bodyContentType: IDictContentType;

  // Категория уведомления (DictNotificationCategory)
  // Нарушения по документам налогового учета (VAT_VIOLATION) / Нарушения по работе с KKM (KKM_VIOLATION)
  category: IDictionaryEntityDto;

  // Тип уведомления
  // Декларация не подана (DECL_ABSENT_1) / Расхождения с СФ (DECL_INVOICE_DIFF_2) / НДС не уплачен (DECL_NOT_FULL_PAID_3)
  type: IDictNotificationType;

  // Вид уведомления
  // Открытие нарушения / Изменение нарушения / Напоминание по нарушению и прочее
  kind: IDictionaryEntityDto;
}
